import type { TextString } from './ReviewHelpers';
import { Question, ValueTypeFromQuestion, getQuestionState } from './ReviewInputs';

export interface Rating<K = string> {
    key: K;
    title: TextString;
    subtitle: TextString;
    questionTree: [number, Question<K>[]][];
}

export interface ReviewConfig<K = string> {
    rating: Rating<K>;
    questions?: Question<K>[];
}

export enum SubmissionState {
    SUBMITTED,
    SUBMITTING,
    NONE,
}

export interface ReviewState<K extends string = string> {
    rating?: number | null; // null indicates skipped
    questions?: Partial<Record<K, ValueTypeFromQuestion<Question<K>>>>;
    currentQuestionIndex?: number;
    submission?: SubmissionState;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValueFromReviewState<Q extends Question>(question: Q, state?: ReviewState<any>) {
    return getQuestionState(question, state?.questions?.[question.key]);
}
